const endpoints = {
  mine: "/me",
  login: "/login",
  logout: "/logout",
  register: "/register",
  exchangeCode: "/exchange-code",
  allBoxes: "/boxes",
  freeBoxes: "/promo",
  boxCategory: "/box",
  popularBoxes: "popular-boxes",
  boxSubCategories: "/sub-categories",
  boxProducts: "/box-products",
  boxCategories: "/box-categories",
  postUserDetils: "/user-details",
  updatePassword: "user/update-password",
  postUserShippingDetails: "/user-details/shipping",
  spinWheel: "/spin-wheel",
  spinFree: "/spin-free",
  addCart: "/add-cart",
  getCart: "/show-cart",
  sellItem: "/sell-items",
  getAllBattles: "/battles",
  getAllBattlesByUser: "/logged-in-battles",
  getBattlesById: "/show-battle",
  postBattles: "/battles",
  ContactUs: "/contact-us",
  BecomeReferrer: "/referrer/request",
  getCoins: "/coins",
  getWalletAddress: "/get-batch-address",
  footerSocialLinks: "/footer-social-link",
  getBalance: "/get-accounts",
  WithDraw: "/with-draw",
  Deposit: "/deposit",
  shipItems: "/shipment",
  faq: "/faq",
  terms: "/term-condition",
  privacy: "/privacy-statment",
  provably: "/provably-fair",
  cookie: "/cookie-policy",
  policy: "/aml-policy",
  joinBattle: (id) => `/battles/${id}/join`,
  Document: "/user-document",
  GetDocument: "/get-user-document",
  GetTransaction: "/show-transaction-history",
  Fairness: "/get-user-seed",
  PostSeed: "/update-user-seed",
  Topup: "/topup",
  Withdrawals: "/withdrawal-data",
  battleCancel: "/battles",
  userAvatar: "/user-avatar",
  avatars: "/droppie-avatars",
  FlipCoin: "/flip-coin-result",
  battlePlayTrigger: "/battle-play",
  FlipStatus: "/flip-status-change",
  footerLogo: "/footer-logo",
  resetPassword: "/user/reset-password",
  forgotPassword: "/user/forgot-password",
  sendVerificationEmail: "/send-verification-email",
  Slider: "/slider",
  notificaiton: "/notifications",
  acknowledgeStart: "/acknowledge-start",
  languages: "/languages",
  ipCheck: "/check-ip",
  pendingWithdrawals: "/pending-withdrawals",
  cancelWithdrawal: "/cancel-withdrawal",
  utm: "/utm",
  promotionPopups: "/popups",
  battleBoxes: "/battles/boxes",
  deleteUser: "/delete-user",
};

export default endpoints;
